
import { IPageSOBP } from "@/neolab-libs/nl-lib3-common";
import { IRecognizedAnswerType } from "./CompareOcrData";
import { IExamInfo } from "@/repositories/model/transfer/IExamInfo";
import { IOcrResult } from "@/ndp/hooks/useStrokeRecognition";
import ProjectSubmissionStore from "@/stores/ProjectSubmissionStore";
import ProjectStore from "@/stores/ProjectStore";
import { ProjectStateType } from "@/repositories/model/support/ProjectStateType";

export default class AnswerUploader {

    private projectCode: string;
    private userCode: string;
    private submissionCode?: string;

    private ncodeRange: { start: IPageSOBP, end: IPageSOBP }
    private examInfoArray: IExamInfo[];

    private codeToRecognizedText: { [questionCode: string]: IOcrResult }

    private projectSubmissionStore: ProjectSubmissionStore;
    private projectStore: ProjectStore;

    constructor(
            projectCode: string,
            userCode: string,
            submissionCode: string | undefined,
            ncodeRange: { start: IPageSOBP, end: IPageSOBP },
            examInfoArray: IExamInfo[],
            codeToRecognizedText: { [questionCode: string]: IOcrResult },
            projectSubmissionStore: ProjectSubmissionStore,
            projectStore: ProjectStore
        ) {

            this.projectCode = projectCode;
            this.userCode = userCode;
            this.submissionCode = submissionCode;

            this.ncodeRange = ncodeRange;
            this.examInfoArray = examInfoArray;

            this.codeToRecognizedText = codeToRecognizedText;

            this.projectSubmissionStore = projectSubmissionStore;
            this.projectStore = projectStore;
    
    }

    public async upload() {


        // make answerslist
        const answerList: IRecognizedAnswerType[] = this.createAnswersFromStrokeMap(this.codeToRecognizedText, this.examInfoArray);

    
        const range = this.ncodeRange;
        
        const isCompletingWithoutSubmissionCode = this.submissionCode == null;
        let submissionCode = this.submissionCode;
        let userCode = this.userCode;
        let projectCode = this.projectCode;

        if (isCompletingWithoutSubmissionCode) {
            // refresh transfer
            const refreshedTransfer = await this.projectSubmissionStore.getSubmissionTransfersWithReturnForStudentPenSubmit(projectCode, userCode);
            submissionCode = refreshedTransfer.submissionCode;
            userCode = refreshedTransfer.userCode;
        }
        
        await this.projectSubmissionStore.uploadAnswerDataAndRenderedPdf({
                    projectCode,
                    userCode,
                    pdfBlobURL: null, // props.pdfWithStroke,
                    answerList: answerList.map(item => ({ ...item, ocrStatus: "done" })),
                    range,
                    submissionCode: submissionCode,
        });
        
        await this.projectStore.updateProjectUserState(projectCode, userCode, ProjectStateType.COMPARED, true);

        
    }

    private createAnswersFromStrokeMap(strokeMap: { [questionCode: string]: IOcrResult }, examInfoArray: IExamInfo[]): IRecognizedAnswerType[] {

        // make answerslist
        const answers: IRecognizedAnswerType[] = [];

        const examList = examInfoArray;
        console.log(`ANSWER ------------------------------------------------------------------`);
        for (let examIndex = 0; examIndex < examList.length; examIndex++) {
            const questions = examList[examIndex].questions;

            for (let questionIndex = 0; questionIndex < questions.length; questionIndex++) {
                let code = examList[examIndex].code + "-" + (questionIndex + 1);
                const ocrResult = strokeMap[code];
                const { ocrStatus, recognizedText } = ocrResult || {};
                console.log(`code: ${code}, answerText: ${ocrResult}`);

                const answer: IRecognizedAnswerType = {
                        projectExamCode: examList[examIndex].code,
                        projectExamQuestionNum: questionIndex + 1,
                        answer: recognizedText,
                        ocrResult: recognizedText,
                        ocrStatus
                };

                answers.push(answer);
            }
        }

        return answers;

    }

}